import { render, staticRenderFns } from "./goodRank.vue?vue&type=template&id=15ec1922&scoped=true&"
import script from "./goodRank.vue?vue&type=script&lang=js&"
export * from "./goodRank.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./goodRank.vue?vue&type=style&index=0&id=15ec1922&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "15ec1922",
  "00f2bc04"
  
)

export default component.exports